import { useState } from "react";
import { Link } from "react-router-dom";
import PartnerInventoryModelGroup from "./PartnerInventoryModelGroup";
import PartnerInventoryUnclassifiedBucket from "./PartnerInventoryUnclassifiedBucket";
import { formatAggregateSummary } from "../../../utils/partnerInventoryFormatters";

function NeedsReviewBadge({ count, reviewPath }) {
  if (!count) return null;
  return (
    <Link className="partner-grouped-review-badge" to={reviewPath} aria-label={`${count} listings need review`}>
      {count} need review
    </Link>
  );
}

export default function PartnerInventoryMakeGroup({
  makeGroup,
  dealerId,
  path,
  reviewPath,
}) {
  const [expanded, setExpanded] = useState(false);
  const summary = formatAggregateSummary(makeGroup.aggregates);

  return (
    <section className="partner-grouped-make" aria-label={`${makeGroup.make?.label || "Make"} group`}>
      <button
        type="button"
        className="partner-grouped-make__toggle"
        aria-expanded={expanded}
        onClick={() => setExpanded((value) => !value)}
      >
        <span className="partner-grouped-make__label">{makeGroup.make?.label || "Unknown make"}</span>
        <span className="muted partner-grouped-make__meta">
          {makeGroup.count} listing{makeGroup.count === 1 ? "" : "s"}
          {summary ? ` · ${summary}` : ""}
        </span>
      </button>
      <NeedsReviewBadge count={makeGroup.aggregates?.needsReviewCount} reviewPath={reviewPath} />

      {expanded ? (
        <div className="partner-grouped-make__body">
          {(makeGroup.models || []).map((modelGroup, index) => (
            <PartnerInventoryModelGroup
              key={`${modelGroup.model?.id || modelGroup.model?.label}-${index}`}
              modelGroup={modelGroup}
              dealerId={dealerId}
              path={path}
              reviewPath={reviewPath}
            />
          ))}
          <PartnerInventoryUnclassifiedBucket
            title="Unclassified model listings"
            count={makeGroup.unclassified?.count || 0}
            reason={makeGroup.unclassified?.reason}
            listings={makeGroup.unclassified?.listings || []}
            dealerId={dealerId}
            path={path}
            reviewPath={reviewPath}
            warningLabel="Model missing"
            showReviewLink={false}
          />
        </div>
      ) : null}
    </section>
  );
}
